import React, { useEffect, useRef, useState } from "react";

/**
 * Fires onTrigger after `idleMs` of no user activity (mouse move, scroll, keypress, touch).
 * Only fires once per session unless resetKey changes.
 */
export default function useIdleTrigger({ idleMs = 30000, onTrigger, sessionKey = "bl_idle_fired" }) {
  const timerRef = useRef(null);
  const firedRef = useRef(false);

  useEffect(() => {
    if (sessionStorage.getItem(sessionKey)) firedRef.current = true;

    const reset = () => {
      if (firedRef.current) return;
      if (timerRef.current) clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => {
        if (firedRef.current) return;
        firedRef.current = true;
        sessionStorage.setItem(sessionKey, "1");
        onTrigger?.();
      }, idleMs);
    };

    const events = ["mousemove", "mousedown", "keydown", "touchstart", "scroll"];
    events.forEach((e) => window.addEventListener(e, reset, { passive: true }));
    reset();

    return () => {
      events.forEach((e) => window.removeEventListener(e, reset));
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [idleMs, onTrigger, sessionKey]);
}
